import React from 'react'
import PropTypes from 'prop-types'
import * as Yup from 'yup'
import { IonButton } from '@ionic/react'
import {
  ADD_TECH_COMMENTS_ACTION,
  TECH_COMMENTS_REQUIRED_MESSAGE,
} from '../constants'
import SectionTextarea from './SectionTextarea'

// Shared "Tech Comments" textarea + Submit used by every partial that offers the
// Add Tech Comments action (rescheduling, in-progress, standalone).
function AddTechCommentsFields({
  idPrefix,
  values,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  isSubmitting,
}) {
  return (
    <>
      <SectionTextarea
        id={`${idPrefix}-tech-comments`}
        name="tech_comments"
        label="Tech Comments"
        value={values.tech_comments}
        error={errors.tech_comments}
        touched={touched.tech_comments}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
      />

      <IonButton
        type="submit"
        color="tss-grey-dark"
        className="accept-decline-section__btn"
        disabled={isSubmitting}
      >
        Submit
      </IonButton>
    </>
  )
}

AddTechCommentsFields.propTypes = {
  idPrefix: PropTypes.string.isRequired,
  values: PropTypes.shape({ tech_comments: PropTypes.string }).isRequired,
  errors: PropTypes.shape({ tech_comments: PropTypes.string }).isRequired,
  touched: PropTypes.shape({ tech_comments: PropTypes.bool }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
}

AddTechCommentsFields.defaultProps = {
  isSubmitting: false,
}

// Validation for the shared field: tech comments are required only while the
// form's action select (`actionFieldName`) is set to Add Tech Comments. Other
// actions may still submit optional tech comments through the same field.
export function techCommentsValidation(actionFieldName) {
  return Yup.string().when(actionFieldName, {
    is: ADD_TECH_COMMENTS_ACTION,
    then: (schema) => schema.trim().required(TECH_COMMENTS_REQUIRED_MESSAGE),
    otherwise: (schema) => schema,
  })
}

export default AddTechCommentsFields
